import { render, staticRenderFns } from "./ConsumerCard.vue?vue&type=template&id=8994b93c&"
import script from "./ConsumerCard.vue?vue&type=script&lang=js&"
export * from "./ConsumerCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports